export default __webpack_public_path__ + "static/media/SoSafe.77bfb067.jpg";